import HTTP from '@/common/HTTP'
import {actionTypes, mutationTypes} from './DatenpoolUploadTypes';
import {indexOf, forEach} from "lodash";

// initial state
const initialState = () => ({
  loading: false, uploadQueue: []
})

// mutations
const mutations = {
  [mutationTypes.SET_UPLOAD_QUEUE](state, value) {
    forEach(value, function (item) {
      // if file isn't already in queue
      if (indexOf(state.uploadQueue, item) === -1) {
        state.uploadQueue.push(item);
      }
    });
  },

  [mutationTypes.SET_LOADING](state, value) {
    state.loading = value
  },

  [mutationTypes.REMOVE_FILE_FROM_QUEUE](state, value) {
    let index = state.uploadQueue.indexOf(value);

    state.uploadQueue.splice(index, 1);
  },
}

// actions
const actions = {
  async [actionTypes.UPLOAD_QUEUE]({state, commit, dispatch}) {
    commit(mutationTypes.SET_LOADING, true)

    const results = await Promise.all(state.uploadQueue.map(async (queueItem) => {
      const formData = new FormData();
      formData.append("file", queueItem);

      try {
        const uploadEndpoint = '/datenpool/upload/user'
        const queueItemResult = await HTTP.post(uploadEndpoint, formData);

        // HTTP STATUS 200 -> successful upload
        console.log(queueItemResult);

        // remove complete file from queue
        commit(mutationTypes.REMOVE_FILE_FROM_QUEUE, queueItem)

        return {
          file: queueItem, success: true, data: queueItemResult
        }
      } catch (error) {
        // HTTP STATUS 4XX / 5XX -> upload failure
        console.log(error);
        return {
          file: queueItem, success: false, data: error
        }
      }
    }))

    this._vm.$notify((results.every((result) => result.success === true)) ? {
      group: 'app',
      title: 'Erfolgreich',
      type: 'success',
      text: 'Alle Dateien wurden erfolgreich hochgeladen.',
      duration: 3000
    } : {
      group: 'app',
      title: 'Fehler',
      type: 'warn',
      text: 'Mindestens eine Datei konnte nicht hochgeladen werden. Erfolgreich hochgeladene Dateien wurden aus der Warteschlange entfernt.',
      color: 'error',
      duration: 6000
    })

    dispatch('DatenpoolFiles/FETCH_FILES', null, {root: true})

    commit(mutationTypes.SET_LOADING, false)
  }
}

export default {
  namespaced: true,
  state: initialState, actions, mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/DatenpoolUpload.js